import { render } from "./HelpCompetitionDialog.vue?vue&type=template&id=0aa4f72a"
import script from "./HelpCompetitionDialog.vue?vue&type=script&lang=js"
export * from "./HelpCompetitionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__